export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-16">
          <div className="flex-1 pr-8">
            <div className="mb-4">
              <span className="text-[#2C5F7C] text-sm font-semibold tracking-wider uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
                Our Story
              </span>
              <div className="w-16 h-0.5 bg-[#2C5F7C] mt-2"></div>
            </div>
            
            <h2 className="text-6xl font-bold text-gray-900 mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Healing Guided by<br />
              <span className="italic">Coastal Wisdom</span>
            </h2>
            
            <div className="space-y-6 text-gray-600 text-lg leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
              <p>
                At Live Your Best Life Therapy & Coaching, we believe in the profound healing power of combining professional psychological care with the tranquil influence of the ocean. Our practice was founded on the principle that true healing occurs when mind, body, and environment work in harmony.
              </p>
              <p>
                With over 15 years of experience in mental health services, our team of licensed therapists specializes in evidence-based treatments tailored to each individual's unique journey. We create a safe, welcoming space where clients can explore their emotions, overcome challenges, and discover their inner strength.
              </p>
              <p>
                Whether you're navigating anxiety, depression, relationship challenges, or seeking personal growth, we're here to guide you toward lasting positive change. Our coastal setting provides the perfect backdrop for reflection, healing, and transformation.
              </p>
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/3c736273a1e006b225855380bbf09fe1.jpg"
                alt="Therapist in coastal setting"
                className="w-full h-[600px] object-cover rounded-3xl shadow-2xl"
                style={{ boxShadow: '0 8px 32px rgba(44, 95, 124, 0.12)' }}
              />
              <div className="absolute -top-6 -right-6 w-24 h-24 flex items-center justify-center">
                <i className="ri-sailboat-line text-6xl text-[#A8DADC]"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
